import { render, staticRenderFns } from "./UploadedNews.vue?vue&type=template&id=61aceac5&scoped=true&"
import script from "./UploadedNews.vue?vue&type=script&lang=js&"
export * from "./UploadedNews.vue?vue&type=script&lang=js&"
import style0 from "./UploadedNews.vue?vue&type=style&index=0&id=61aceac5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aceac5",
  null
  
)

export default component.exports